import { createTheme, textSize } from '@kis-technologies/kis-ui';

interface ThemeOptions {
  palette?: {
    primary: string;
    secondary: string;
  };
  fonts?: {
    primary: string;
    secondary?: string;
  };
}

const localTheme = (options: ThemeOptions = {}) => {
  return createTheme({
    typography: {
      fontFamily: options?.fonts?.primary || 'Poppins, sans-serif',
      h2: {
        fontSize: textSize.kiosk.H2,
        fontWeight: 600,
        lineHeight: 1.5
      },
      h4: {
        fontSize: textSize.kiosk.H4,
        fontWeight: 600
      },
      h5: {
        fontSize: textSize.kiosk.H5,
        fontWeight: 600
      },
      h6: {
        fontSize: textSize.kiosk.H6,
        fontWeight: 600
      }
    },
    palette: {
      primary: {
        main: options?.palette?.primary || '#f46d2e'
      },
      secondary: {
        main: options?.palette?.secondary || '#222930'
      },
      background: {
        default: '#FAFAFA'
      },
      text: {
        primary: '#222930',
        secondary: '#F46D2E'
      }
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          stickyHeader: {
            backgroundColor: '#FAFAFA'
          }
        }
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: '30px' // Set the default font-size for the body
          }
        }
      },
      MuiContainer: {
        styleOverrides: {
          maxWidthLg: {
            maxWidth: '1720px',
            '@media (min-width:1200px)': {
              maxWidth: '1720px'
            }
          }
        }
      }
    }
  });
};

export default localTheme;
